export const SET_SECTOR_UI_FLAG = 'SET_SECTOR_UI_FLAG';
export const CLEAR_SECTORS = 'CLEAR_SECTORS';
export const SET_SECTORS = 'SET_SECTORS';
export const SET_SECTOR_ITEM = 'SET_SECTOR_ITEM';
export const EDIT_SECTOR = 'EDIT_SECTOR';
export const DELETE_SECTOR = 'DELETE_SECTOR';
export const SET_ACTIVE_SECTOR = 'SET_ACTIVE_SECTOR';
export const SET_ALL_SECTORS = 'SET_ALL_SECTORS';
